/* EDITOR */
Vue.component('companyeditor',{
    template:'#companyeditor-template',
    data:function(){
        return{
            company: [],
            activeTab:'personaldata',
            backupRecord:[],
            password:'',
            password_verify:'',
            passwordFieldIsActive:false
        };
    },
    created:function(){
        activeInstance = this;

        var id = $('#content_wrapper').attr('data-id');
        showLoadingOverlay();
        Vue.http.get(baseURL+'/api/company/list/'+id).then(function(response){
            $('body').LoadingOverlay("hide");

            $(response.data[0].shippingdata).each(function(index,record){
                record.locked = true;
            });

            $(response.data[0].personaldata).each(function(index,record){
                record.locked = true;
            });

            $(response.data[0].invoicedata).each(function(index,record){
                record.locked = true;
            });

            activeInstance.company = response.data;
            console.log(response);
        }).bind(this);
    },
    methods:{
        checkPassword:function(){

            re = /^\w+$/;
            if(activeInstance.password != "" && activeInstance.password == activeInstance.password_verify) {
                if(activeInstance.password.length < 6) {
                    errorNotification("Hiba: A jelszónak legalább 6 karakter hosszúnak kell lennie!");
                    return false;
                }
                re = /[0-9]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy számnak szerepelnie kell!");
                    return false;
                }
                re = /[a-z]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy kisbetűnek szerepelnie kell (a-z)!");
                    return false;
                }
                re = /[A-Z]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy nagybetűnek szerepelnie kell (A-Z)!");
                    return false;
                }
            } else {
                if(activeInstance.password==""){
                    errorNotification("Hiba: A jelszó nincs kitöltve");
                    return false;
                }
                else{
                    errorNotification("Hiba: A jelszó nem egyezik a megerősítéssel.");
                    return false;
                }

            }
            return true;
        },
        togglePasswordField:function(){
            if(activeInstance.passwordFieldIsActive == true){
                activeInstance.passwordFieldIsActive = false;
            }
            else{
                activeInstance.passwordFieldIsActive = true;
            }
        },
        updatecompanyPassword:function(){
            var validated = activeInstance.checkPassword();
            if(validated == true){
                bootbox.confirm('Biztosan mented az új jelszót?', function(value){
                    if(value==true){
                        showLoadingOverlay();
                        Vue.http.post(baseURL+'/admin/company/update/password', {'company':activeInstance.company,'password':activeInstance.password}).then(function(response){
                            $('body').LoadingOverlay("hide");
                            successNotification('Jelszó sikeresen frissítve');
                        }).bind(this);
                    }
                });
            }
        },
        updatecompanyNameAndEmail:function(){
            bootbox.confirm('Biztosan mented az új jelszót?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/company/update/name_and_email', {'company':activeInstance.company,'password':activeInstance.password}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('Jelszó sikeresen frissítve');
                    }).bind(this);
                }
            });
        },
        toggleShippingRecordLock:function(record){

            if(record.locked==false){
                record.locked=true;
            }else{
                record.backup =  JSON.parse( JSON.stringify( record ) );
                record.locked=false;
            }

        },
        togglePersonalRecordLock:function(record){

            if(record.locked==false){
                record.locked=true;
            }else{
                record.backup =  JSON.parse( JSON.stringify( record ) );
                record.locked=false;
            }

        },
        toggleInvoiceRecordLock:function(record){

            if(record.locked==false){
                record.locked=true;
            }else{
                record.backup =  JSON.parse( JSON.stringify( record ) );
                record.locked=false;
            }

        },
        cancelPersonalEdit:function(record){
            record.firstname = record.backup.firstname;
            record.postcode = record.backup.postcode;
            record.town = record.backup.town;
            record.street = record.backup.street;
            record.floor_door = record.backup.floor_door;
            record.phone = record.backup.phone;
            record.locked=1;
        },
        cancelShippingEdit:function(record){
            record.firstname = record.backup.firstname;
            record.postcode = record.backup.postcode;
            record.town = record.backup.town;
            record.street = record.backup.street;
            record.floor_door = record.backup.floor_door;
            record.phone = record.backup.phone;
            record.locked=1;
        },
        cancelInvoiceEdit:function(record){
            record.firstname = record.backup.firstname;
            record.postcode = record.backup.postcode;
            record.town = record.backup.town;
            record.street = record.backup.street;
            record.floor_door = record.backup.floor_door;
            record.phone = record.backup.phone;
            record.locked=1;
        },
        updatePersonalRecord:function(record){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/address/update',{record:record, type:"personal"}).then(function(response){
                $('body').LoadingOverlay("hide");
                console.log(response);
                successNotification('Sikeres mentés');
            });
        },
        updateShippingRecord:function(record){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/address/update',{record:record, type:"shipping"}).then(function(response){
                $('body').LoadingOverlay("hide");
                console.log(response);
                successNotification('Sikeres mentés');
            });
        },
        updateInvoiceRecord:function(record){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/address/update',{record:record, type:"invoice"}).then(function(response){
                $('body').LoadingOverlay("hide");
                console.log(response);
                successNotification('Sikeres mentés');
                record.locked=true;
            });
        },

        //DESTROY
        deleteShippingRecord:function(record){

            bootbox.confirm('Biztosan el akarod távolítani ezt a címet?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/address/delete', {record:record, type:"shipping"}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.company[0].shippingdata.$remove(record);
                        successNotification('Sikeres törlés');
                    }).bind(this);
                }
            });

        },
        deleteInvoiceRecord:function(record){
            bootbox.confirm('Biztosan el akarod távolítani ezt a címet?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/address/delete', {record:record, type:"invoice"}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.company[0].invoicedata.$remove(record);
                        successNotification('Sikeres törlés');
                    }).bind(this);
                }
            });
        },
        save:function(){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/company/update',{company:activeInstance.company[0]}).then(function(response){
                $('body').LoadingOverlay("hide");
                console.log(response);
                successNotification('Sikeres mentés');
                setTimeout(function(){
                    location.href=baseURL+"/admin/companies";
                },600);
            });
        }
    }
});